import SideNav from "@/components/desktop/navigation/side-nav";
import TopNav from "@/components/desktop/navigation/top-nav";
import { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { ScrollShadow, useOverlayState } from "@heroui/react";
import CreateMeetsDrawer from "@/components/desktop/drawers/create-meets-drawer";
import MobileMenuDrawer from "@/components/desktop/drawers/mobile-menu-drawer";
import "@/styles/desktop.css";
import DesktopCreateQuickMeetsDrawer from "@/components/desktop/drawers/desktop-create-quick-meet-drawer";

const DesktopLayout = () => {
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (params.get('create') === '1') {
      setShowCreateMeets(true);
      setParams(prev => { prev.delete('create'); return prev; }, { replace: true });
    }
  }, [params, setParams]);
  const [showCreateMeets, setShowCreateMeets] = useState(false);
  const [showQuickMeets, setShowQuickMeets] = useState(false);

  const [refresh, setRefresh] = useState(0);

  const navDrawerState = useOverlayState();

  const handleRefresh = () => setRefresh((n) => n + 1);

  return (
    <div className="flex h-dvh max-h-dvh flex-col overflow-hidden bg-background lg:flex-row">
      <aside className="hidden max-h-dvh shrink-0 py-4 ps-4 nav:flex lg:flex-col">
        <SideNav />
      </aside>

      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <header className="shrink-0 px-4 pt-4">
          <TopNav
            onCreateMeetsClick={() => setShowCreateMeets(true)}
            onRefresh={handleRefresh}
            onMenuOpen={() => navDrawerState.open()}
            onCreateQuickMeetsClick={() => setShowQuickMeets(true)}
          />
        </header>

        <main className="min-h-0 min-w-0 flex-1 overflow-hidden">
          <ScrollShadow size={24} className="h-full min-w-0 overflow-y-auto">
            <Outlet context={{ refresh }} />
          </ScrollShadow>
        </main>
      </div>

      <CreateMeetsDrawer
        show={showCreateMeets}
        onResp={(action) => {
          if (action === "close") setShowCreateMeets(false);

          if (action === "success") {
            setShowCreateMeets(false);
            handleRefresh();
          }
        }}
      />

      <DesktopCreateQuickMeetsDrawer _show={showQuickMeets} _setShow={setShowQuickMeets} />

      <MobileMenuDrawer state={navDrawerState} />
    </div>
  );
};

export default DesktopLayout;